/**
 * Trip view/edit mode (UI-only Zustand state). The trip page starts in `view`
 * so items can't be checked off by accident; the header toggle flips to `edit`
 * to enable check-off. Tapping Edit a second time toggles `editAll`: every list
 * card opens for reorder + quick-add at once. View is always the full way out.
 * Server data still lives in TanStack Query.
 */
import { create } from 'zustand';

export type TripMode = 'view' | 'edit';

interface TripModeState {
  mode: TripMode;
  /** Every list card is in its "Edit list" state (only meaningful in `edit`). */
  editAll: boolean;
  setMode: (mode: TripMode) => void;
  toggle: () => void;
  setEditAll: (editAll: boolean) => void;
  toggleEditAll: () => void;
}

export const useTripModeStore = create<TripModeState>((set) => ({
  mode: 'view',
  editAll: false,
  // Leaving Edit ends the edit-all pass too; entering it leaves the flag alone.
  setMode: (mode) => set(mode === 'view' ? { mode, editAll: false } : { mode }),
  toggle: () =>
    set((state) => (state.mode === 'view' ? { mode: 'edit' } : { mode: 'view', editAll: false })),
  setEditAll: (editAll) => set({ editAll }),
  toggleEditAll: () => set((state) => ({ editAll: !state.editAll })),
}));
